export const defaultExcercises = {
  name: '',
  reps: undefined,
  sets: undefined,
  duration: undefined,
  category: 0,
  description: '',
  restTime: undefined,
  level: 0,
  upperBody: undefined,
  lowerBody: undefined,
};

export const defaultLessons = {
  name: '',
  exercises: [],
  type: 0,
};

export const defaultCourses = {
  name: '',
  lessons: [],
};

export const defaultScoringRule = {
  min: 0,
  max: 0,
  score: 0,
  id: '',
  parentId: '',
};

export const defaultFunctionalTest = {
  name: '',
  maxScore: undefined,
  type: '',
  thresholdTime: undefined,
  video: '',
  thumbnail: '',
  scoreRules: [{ ...defaultScoringRule }],
  method: '',
  isSO2AndHR: false,
  isAddition: false,
};

export const defaultAssessment = {
  name: '',
  isClass: false,
  isOnboarding: false,
  isDefault: false,
  functionalTests: [],
};
